<template>
  <v-card elevation="2">
    <div class="pa-4">
      <div class="d-flex align-center mx-n2" style="height: 28px">
        <v-spacer></v-spacer>
        <ResetButton
          :text="$t('app.resetFilters')"
          :show="highlightFreezedBySankey"
          @reset="resetHighlight"
        />
        <InstructionIcon v-model="showInstruction" />
        <InstructionList
          :show="showInstruction"
          :list="$t('sankey.instructions')"
        />
      </div>
    </div>
    <RectangularSankey />
  </v-card>
</template>

<script>
import InstructionList from "@/components/InstructionList.vue";
import InstructionIcon from "@/components/InstructionIcon.vue";
import ResetButton from "@/components/ResetButton.vue";
import RectangularSankey from "./RectangularSankey.vue";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    InstructionList,
    InstructionIcon,
    ResetButton,
    RectangularSankey
  },
  data: () => ({
    showInstruction: false
  }),
  computed: {
    ...mapState([
      "isShowingInstructionIcons",
      "highlightFreezed",
      "interactingCategory"
    ]),
    highlightFreezedBySankey() {
      return (
        this.highlightFreezed &&
        this.interactingCategory &&
        this.interactingCategory.startsWith("SANKEY")
      );
    }
  },
  methods: {
    ...mapMutations(["updateHighlightFreezed"]),
    ...mapActions(["resetHighlight"])
  }
};
</script>
